import PropTypes from 'prop-types';

import Icon from '@/components/common/iconedLinks/Icon';
import styles from './ConfirmMessage.module.scss';
import { URLS } from '@/constants/urls';

export const ConfirmMessage = ({ isError, info, save }) => (
  <div className={styles.container}>
    <div className={styles.info} data-test-id="info">
      {info}
    </div>
    <div className={`${styles.save} ${isError ? styles.error : styles.success}`} data-test-id="save">
      {isError ?
        <Icon src={URLS.DELETE_CIRCLE_ICON_BLACK} alt="not-confirmed" /> :
        <Icon src={URLS.CHECKBOX_CONFIRM_CIRCLE_GREEN} alt="confirmed" />
      }
      {save}
    </div>
  </div>
);

ConfirmMessage.propTypes = {
  isError: PropTypes.bool,
  info: PropTypes.string,
  save: PropTypes.string
};

export default ConfirmMessage;
